const VotingAppSettings = {
    IMAGE_URL: 'https://d16qdts2d81gbn.cloudfront.net/',
    API_PUBLIC_URL: 'https://voting-app-api.kiwanis.org/'
};

export default VotingAppSettings;